export enum RegisterState {
	LOGOUT = "LOGOUT",
	LOGGED = "LOGGED",
	VERIFY = "VERIFY",
	ROLE = "ROLE",
	INFOS = "INFOS",
	CATEGORIES = "CATEGORIES",
	FOLLOWS = "FOLLOWS",
	FINISHED = "FINISHED",
}
